import { render } from "./OfferDetailsV2.vue?vue&type=template&id=9da28c96&scoped=true"
import script from "./OfferDetailsV2.vue?vue&type=script&lang=js"
export * from "./OfferDetailsV2.vue?vue&type=script&lang=js"

import "./OfferDetailsV2.vue?vue&type=style&index=0&id=9da28c96&scoped=true&lang=css"
import "./OfferDetailsV2.vue?vue&type=style&index=1&id=9da28c96&lang=css"

import exportComponent from "../../../../../Users/matteocoffin/Documents/ecommerce-ouicsport copie 4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9da28c96"]])

export default __exports__